import SidePanel from './SidePanel'

export default SidePanel
// eslint-disable-next-line import/export
export * from './SidePanel'
